module.exports = __webpack_public_path__ + "img/167.2d89fb89.jpg";